<template>
  <div class="search-client--container">
    <vue-multiselect
      v-model="clientSearch"
      :options="options"
      :custom-label="nameWithNumber"
      :searchable="true"
      :internal-search="false"
      :preserve-search="false"
      :loading="isLoading"
      :selectLabel="'Выбрать'"
      :deselectLabel="'Отменить'"
      :selectedLabel="'Выбрано'"
      @search-change="asyncFind"
      @select="selectClient"
      @remove="resetSelectClient"
      placeholder="Поиск по номеру/имени/фамилии"
    >
      <span slot="noResult">
        Ничего не найдено
      </span>
      <span slot="noOptions">Список пуст, начните вводить данные для поиска</span>
      <div v-if="!hideAdd" class="add-new-client" slot="afterList">
        <div @click="addClient" class="btn btn-sm btn-info">
          Добавить нового клиента
        </div>
      </div>
    </vue-multiselect>

    <input type="hidden" >

    <popup
      :closeButton="newClient.closeButton"
      :show="newClient.show"
      @closePopup="closeNewClientPopup"
    >
      <div slot="header">Добавить клиента</div>
      <div slot="body">
        <add-client
          v-if="newClient.show"
          @addClient="selectClient"
          @existsClient="existsClient"
          :reset="newClient.show"
          :search="searchString"
        ></add-client>
      </div>
    </popup>
  </div>
</template>

<script>
import VueMultiselect from "vue-multiselect";
import Popup from "../../Popup";
import AddClient from "./AddClient";
import clientsRepository from "../../../repositories/clients";

import Formatter from "../../libraries/Formatter";
const formatter = new Formatter();

export default {
  name: "SearchClient",
  components: { AddClient, Popup, VueMultiselect },
  data() {
    return {
      searchString: "",
      clientSearch: null,
      options: [],
      isLoading: false,
      newClient: {
        show: false,
        closeButton: "Отмена"
      }
    };
  },
  props: {
    selected: Object|null, // Данные клиента, которого нужно проставить выбранным по умолчанию
    reset: Number, // Сброс компонента
    hideAdd: Boolean, // Скрывает кнопку добавления нового клиента
  },
  watch: {
    selected: function(val) {
      this.clientSearch = val;
      this.selectClient(val);
    },
    reset: function() {
      this.clientSearch = null;
      this.options = [];
    }
  },
  computed: {

  },
  methods: {
    nameWithNumber({ name, surname, number, sale, is_unwanted }) {
      let text = `${name} ${surname ? surname : ""}/ ${formatter.phoneNumberToMask(number)}${sale ? " - "+sale+"%" : ""}`;
      if(+is_unwanted === 1){
        text += ` (нежелательный)`;
      }
      return text;
    },
    existsClient(number){
      this.closeNewClientPopup();
      clientsRepository.search({query: number}).then(resp => {
        if(resp.data.length){
          this.selectClient(resp.data[0]);
          this.$store.dispatch("addNotification", {
            text: 'Сработал автовыбор',
            time: 4,
            color: "warning"
          });
        }
        this.options = resp.data;
      }).catch(err => {
        this.isLoading = false;
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    asyncFind(query) {
      if (query.length) {
        this.searchString = query;
        this.isLoading = true;
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          clientsRepository.search({query: query}).then(resp => {
            this.options = resp.data;
            this.isLoading = false;
          }).catch(err => {
            this.isLoading = false;
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
        }, 800);
      }
    },
    selectClient(val) {
      this.options = [];
      this.options.push(val);
      this.clientSearch = val;
      this.newClient.show = false;
      this.emitClient();
    },
    resetSelectClient() {
      this.clientSearch = null;
      this.emitClient();
    },
    emitClient() {
      this.$emit("input", this.clientSearch);
    },
    addClient() {
      this.newClient.show = true;
    },
    closeNewClientPopup() {
      this.newClient.show = false;
    }
  },
  created(){
    if(this.selected && Object.keys(this.selected).length){
      this.clientSearch = this.selected;
      this.selectClient(this.selected);
    }
  }
};
</script>

<style scoped lang="less">
.add-new-client {
  padding: 8px 0;
  text-align: center;
}
</style>
